<script>
export default {
  components: {}
};
</script>

<style scoped>

@media all and (max-width: 400px) {
    #auth-container {
        /* background-image: url('~@/assets/images/background/back.jpg'); 
        height: 100%; */
    } 
}

@media all and (min-width: 401px) {
    #auth-container {
  
  /*background-image: url('~@/assets/images/background/back.jpg');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
  
  height: 1080px;*/
  
  
  /*position:fixed; 
  left:0;
  top:0;
  right:0;
  bottom:0;
  background: url('~@/assets/images/background/back.jpg');
  background-size:cover;
  background-position:center center;
  z-index:0;
  height: 1080px;*/

  


  /*background-image: url('~@/assets/images/background/back.jpg'); 
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: local;*/
  /*height: 950px;*/



}

}




  @media all and (min-width: 1390px) {
    #auth-container {
        zoom: 100%;
    } 
  }

    @media all and (max-width: 1390px) {
    #auth-container {
        zoom: 70%;
    } 

    }

  @media all and (max-width: 800px) {
    #auth-container {
        zoom: 50%;
    } 
  }

  @media screen and (max-width: 500px) {
  #auth-container {
        zoom: 100%;
    } 
  }



</style>

<template>
  <div id="auth-container" class="" >
    <vue-snotify></vue-snotify>
    <!-- <div class="account-pages my-0 pt-0 my-sm-5 pt-sm-5 "> -->
      <!-- <div class=""> -->
        <slot />
      <!-- </div> -->
    <!-- </div> -->
  </div>
</template>
